<div class="relative w-full flex flex-col aspect-9/18 rounded-sm overflow-hidden max-w-80">

    <div class="pointer-events-none absolute top-0 left-0 z-30 w-full h-full flex flex-col">
        <div class="shrink-0 w-full flex flex-col">
            <div class="flex flex-row items-center justify-between px-2 pt-0.5">
                <p class="text-xs text-[#fff]">9:42</p>
                <div class="flex flex-row items-center gap-x-1 text-[#fff]">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-3">
                        <path
                            d="M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75ZM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 0 1-1.875-1.875V8.625ZM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 0 1 3 19.875v-6.75Z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-3">
                        <path d="M12 20h.01" />
                        <path d="M2 8.82a15 15 0 0 1 20 0" />
                        <path d="M5 12.859a10 10 0 0 1 14 0" />
                        <path d="M8.5 16.429a5 5 0 0 1 7 0" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-3">
                        <path d="M10 14v-4" />
                        <path d="M22 14v-4" />
                        <path d="M6 14v-4" />
                        <rect x="2" y="6" width="16" height="12" rx="2" />
                    </svg>
                </div>
            </div>

            <div class="flex flex-row w-full px-2 pt-2">
                <div class="flex-1 flex flex-row gap-x-4 items-center justify-center">
                    <div class="border-b border-b-transparent py-1">
                        <p class="text-xs text-[#fff]/50">Following</p>
                    </div>
                    <div class="border-b border-b-[#fff] py-1">
                        <p class="text-xs text-[#fff]">For You</p>
                    </div>
                </div>
                <div class="shrink-0 px-2 flex flex-col items-center justify-center text-[#fff]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4">
                        <path d="m21 21-4.34-4.34" />
                        <circle cx="11" cy="11" r="8" />
                    </svg>
                </div>
            </div>
        </div>


        <div class="flex-1 flex flex-col items-start justify-end">
            <div class="w-full flex flex-row items-end justify-between gap-x-6">
                <div class="flex-1 flex flex-col gap-y-1 p-1">
                    <p class="text-xs text-[#fff]">{{ getIdentityTypeText() }}</p>
                    <p class="text-xs text-[#fff]">{{ createSparkCampaignService.ad_text() ?? 'Your text will be shown here' }}</p>
                    <span
                        class="inline-flex w-fit self-start items-center rounded-sm bg-[#4D4D4D80] px-2 py-0.5 text-[8px] font-medium text-[#fff]">Sponsored</span>
                    @if (createSparkCampaignService.call_to_action_active()) {
                    <button type="button"
                        class="w-full flex items-center justify-center rounded-sm bg-[#fe2c55] px-2 py-1 text-[8.5px] font-semibold text-[#fff]">{{
                        getCTAButtonText() }}</button>
                    }
                </div>
                <div class="shrink-0 p-1 flex flex-col gap-y-2">
                    <div class="size-8 rounded-full bg-red-500 p-0.5">
                        <img class="size-full object-cover rounded-full"
                            src="../../../../../../../assets/images/tiktok-goofy.png" alt="">
                    </div>
                    <div class="flex flex-col gap-y-0.5 items-center justify-center text-[#fff]">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                            <path
                                d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
                        </svg>
                        <p class="text-xs">991k</p>
                    </div>
                    <div class="flex flex-col gap-y-0.5 items-center justify-center text-[#fff]">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                            <path fill-rule="evenodd"
                                d="M4.804 21.644A6.707 6.707 0 0 0 6 21.75a6.721 6.721 0 0 0 3.583-1.029c.774.182 1.584.279 2.417.279 5.322 0 9.75-3.97 9.75-9 0-5.03-4.428-9-9.75-9s-9.75 3.97-9.75 9c0 2.409 1.025 4.587 2.674 6.192.232.226.277.428.254.543a3.73 3.73 0 0 1-.814 1.686.75.75 0 0 0 .44 1.223ZM8.25 10.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z"
                                clip-rule="evenodd" />
                        </svg>
                        <p class="text-xs">3456</p>
                    </div>
                    <div class="flex flex-col gap-y-0.5 items-center justify-center text-[#fff]">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                            <path fill-rule="evenodd"
                                d="M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z"
                                clip-rule="evenodd" />
                        </svg>
                        <p class="text-xs">810</p>
                    </div>
                    <div class="flex flex-col gap-y-0.5 items-center justify-center text-[#fff]">
                        <svg id="fi_2550240" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512"
                            width="512" xmlns="http://www.w3.org/2000/svg" fill="#fff" class="size-5">
                            <path
                                d="m494.533 172.016-115.899-115.899c-9.563-9.563-19.263-14.412-28.829-14.412-13.135 0-28.472 9.99-28.472 38.146v39.457c-84.204 3.67-162.839 38.203-222.815 98.176-63.524 63.52-98.512 147.975-98.518 237.809 0 6.454 4.128 12.186 10.25 14.229 1.563.521 3.163.772 4.748.772 4.627 0 9.106-2.147 11.994-5.991 70.819-94.266 177.439-149.975 294.341-154.373v38.85c0 28.154 15.337 38.146 28.471 38.146h.003c9.565 0 19.265-4.849 28.827-14.411l115.898-115.901c11.265-11.261 17.468-26.283 17.468-42.299 0-16.013-6.203-31.036-17.467-42.299z">
                            </path>
                        </svg>
                        <p class="text-xs">1256</p>
                    </div>
                </div>
            </div>
            @if (createSparkCampaignService.enable_disclaimer() && createSparkCampaignService.disclaimer_text() &&
            createSparkCampaignService.disclaimer_text()!.length > 0) {
            <div class="w-full p-0.5 flex flex-row items-center gap-x-1 bg-gray-900/40 text-[#fff]">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-3">
                    <path fill-rule="evenodd"
                        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                        clip-rule="evenodd" />
                </svg>
                <p class="text-[9px] text-[#fff]">{{ createSparkCampaignService.disclaimer_text() }}</p>

            </div>
            }
        </div>


        <div class="shrink-0 pb-2 pt-0.5 px-2 bg-[#000] flex flex-row items-center justify-between">
            <div class="flex flex-col gap-y-0.5 items-center justify-center text-[#fff]">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-4">
                    <path
                        d="M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z" />
                    <path
                        d="m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z" />
                </svg>
                <p class="text-xs">Home</p>
            </div>
            <div class="flex flex-col gap-y-0.5 items-center justify-center text-[#fff]">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <circle cx="9" cy="7" r="4" />
                </svg>
                <p class="text-xs">Friends</p>
            </div>

            <div class="flex flex-col gap-y-1 items-center justify-center">

                <div
                    class="bg-[#fff] rounded-sm px-2 py-0.5 border-l-2 border-l-teal-500 border-r-2 border-r-rose-500 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                    </svg>
                </div>

            </div>

            <div class="flex flex-col gap-y-0.5 items-center justify-center text-[#fff]">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-4">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                </svg>

                <p class="text-xs">Inbox</p>
            </div>
            <div class="flex flex-col gap-y-0.5 items-center justify-center text-[#fff]">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4">
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                </svg>
                <p class="text-xs">Me</p>
            </div>
        </div>
    </div>

    <div class="bg-gray-400 h-full w-full flex flex-col items-center justify-center">
        @if (createSparkCampaignService.selectedCreative()) {
        <div class="h-full w-full flex flex-col items-center justify-center">
            <div class="group relative h-full w-auto aspect-9/16 overflow-hidden" (mouseenter)="setVideoHovered(true)"
                (mouseleave)="setVideoHovered(false)">
                <video #previewVideo [src]="createSparkCampaignService.selectedCreative()!.video_info.embed_url"
                    playsinline preload="metadata" (play)="onVideoPlay()" (pause)="onVideoPause()"
                    (ended)="onVideoPause()"
                    [class]="hasStartedVideo() ? 'absolute inset-0 h-full w-full object-cover' : 'absolute inset-0 h-full w-full object-cover opacity-0'"></video>
                @if (!hasStartedVideo()) {
                <img class="absolute inset-0 h-full w-full object-cover"
                    [src]="createSparkCampaignService.selectedCreative()!.video_info.thumbnail_url" alt="">
                }

                @if (!isVideoPlaying() || isVideoHovered()) {
                <button type="button" (click)="$event.stopPropagation(); toggleVideoPlayback(previewVideo)"
                    class="absolute inset-0 z-20 flex items-center justify-center focus:outline-hidden">
                    <span
                        class="inline-flex size-11 items-center justify-center rounded-full bg-black/65 text-white ring-1 ring-white/20 transition hover:bg-black/75">
                        @if (isVideoPlaying()) {
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-5"
                            aria-hidden="true">
                            <path
                                d="M8.25 6A2.25 2.25 0 0 1 10.5 8.25v7.5A2.25 2.25 0 0 1 8.25 18h-.75A2.25 2.25 0 0 1 5.25 15.75v-7.5A2.25 2.25 0 0 1 7.5 6h.75Zm8.25 0a2.25 2.25 0 0 1 2.25 2.25v7.5A2.25 2.25 0 0 1 16.5 18h-.75a2.25 2.25 0 0 1-2.25-2.25v-7.5A2.25 2.25 0 0 1 15.75 6h.75Z" />
                        </svg>
                        } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                            class="ml-0.5 size-5" aria-hidden="true">
                            <path
                                d="M8.28 5.31A1 1 0 0 0 6.75 6.16v11.68a1 1 0 0 0 1.53.85l9.12-5.84a1 1 0 0 0 0-1.68L8.28 5.31Z" />
                        </svg>
                        }
                    </span>
                    <span class="sr-only">{{ isVideoPlaying() ? 'Pause video' : 'Play video' }}</span>
                </button>
                }
            </div>
        </div>
        } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="size-12 text-gray-100">
            <rect width="18" height="18" x="3" y="3" rx="2" />
            <path d="M7 3v18" />
            <path d="M3 7.5h4" />
            <path d="M3 12h18" />
            <path d="M3 16.5h4" />
            <path d="M17 3v18" />
            <path d="M17 7.5h4" />
            <path d="M17 16.5h4" />
        </svg>
        }
    </div>
</div>